/* The organization's "Latencia y errores por modelo y paso" (owner 2026-10-19): a head with its
   window and export, then the table, the way Plataforma > Estado draws it. */
.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--space-3);
}

.titles {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-1);
  min-inline-size: 0;
}

.title {
  margin: 0;
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-semibold);
}

.meta {
  margin: 0;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

/* The period's select keeps its own width (mockup `.select` with `width:auto`). */
.period {
  flex: none;
}
